module.exports = __webpack_public_path__ + "media/images/battery-100-17d1a178347f0284a227a1c5808e089c.png";